var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor',{attrs:{"id":_vm.data_id,"data":_vm.id,"default-tab":_vm.defaultTab || 'list_data',"tabs":_vm.tabs}})}
var staticRenderFns = []

export { render, staticRenderFns }